import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';

const LoginButton = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error('Login redirect failed:', e);
    });
  };

  return (
    <button 
      onClick={handleLogin} 
      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
    >
      Sign In with Microsoft
    </button>
  );
};

export default LoginButton;